export default "__VITE_ASSET__CgLNoAAF__"